// Module
var code = `<div class="buttons">
  <button
    class="btn btn-primary"
    ng-disabled="!\$ctrl.hasValidFilter()"
    ng-click="\$ctrl.generate()">
    Generate
  </button>
</div>

<div ng-if="\$ctrl.showTable">
  <h2>Please select collections for payment:</h2>
</div>

<div ng-if="\$ctrl.searchBy === 'INDIVIDUAL' && \$ctrl.showTable">
  <collections-payment-individual
    table-config="\$ctrl.individualTableConfig"
    collections-receipt-type="\$ctrl.collectionsReceiptType"
    collection-module-receipt-required="\$ctrl.collectionModuleReceiptRequired"
    toggle-for-payment="\$ctrl.toggleForPayment(collection)"
    get-payment="\$ctrl.getPayment(productId)"
    get-payments-total-amount="\$ctrl.getPaymentsTotalAmount()"
  ></collections-payment-individual>
</div>

<div ng-if="\$ctrl.searchBy === 'GROUP' && \$ctrl.showTable">
  <collections-payment-group
    table-config="\$ctrl.groupTableConfig"
    show-group-members-modal="\$ctrl.showGroupMembersModal(group)"></collections-payment-group>
</div>

<div class="alert alert--danger" ng-if="\$ctrl.noOfficialReceiptAvailable">
  <span>User has no available official receipts</span>
</div>

<div ng-if="\$ctrl.showTable" class="buttons">
  <div ng-if="\$ctrl.valueDateEnabled" class="labelled-field">
    <label>Value Date</label>
    <value-date ng-model="\$ctrl.valueDate"></value-date>
  </div>
  <button class="btn btn-warning" ng-disabled="\$ctrl.getPayments().length === 0" ng-click="\$ctrl.clearPayments()">Clear all</button>
  <button class="btn btn-success" ng-disabled="!\$ctrl.isValidPayments()" ng-click="\$ctrl.proceedPayment(true)">Confirm payment</button>
</div>

<collections-payment-members-modal
  table-config="\$ctrl.groupMembersTableConfig"
  members-modal="\$ctrl.membersModal"
  selected-group="\$ctrl.selectedGroup"
  selected-page-for-payment="\$ctrl.selectedPageForPayment"
  sort-by="\$ctrl.groupMembersSortBy"
  collections-receipt-type="\$ctrl.collectionsReceiptType"
  collection-module-receipt-required="\$ctrl.collectionModuleReceiptRequired"
  value-date-enabled="\$ctrl.valueDateEnabled"
  value-date="\$ctrl.valueDate"
  toggle-for-payment="\$ctrl.toggleForPayment(collection)"
  toggle-page-for-payment="\$ctrl.togglePageForPayment(collectionPage)"
  get-payment="\$ctrl.getPayment(productId)"
  get-payments="\$ctrl.getPayments()"
  get-payments-total-amount="\$ctrl.getPaymentsTotalAmount()"
  clear-payments="\$ctrl.clearPayments()"
  is-valid-payments="\$ctrl.isValidPayments()"
  proceed-payment="\$ctrl.proceedPayment(showConfirmation)"
  prepare-group-members-table="\$ctrl.prepareGroupMembersTable(group)"
></collections-payment-members-modal>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/collections/payment/collections-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;